module.exports = __webpack_public_path__ + "static/devfestparis2020-af2396e324f7090bc5debb65d3e6cc39.png";